import React, { useMemo } from "react";
import { PageLink, Paragraph } from "shared/components";
import { useLazyRenderingState } from "shared/components/LazyRenderingButton";

import styles from "./Items.module.scss";

export const Items = ({ items }) => {
  const { limit } = useLazyRenderingState();

  const slicedItems = useMemo(() => {
    return items.slice(0, limit);
  }, [items, limit]);

  return (
    <div className={styles.items}>
      {slicedItems.map((item) => {
        return (
          <PageLink
            directory="events"
            slug={item.slug}
            key={item.id}
            className={styles.link}
          >
            <div className={styles.item}>
              <div className={styles.content}>
                <div>
                  <Paragraph className={styles.category} color="grey" uppercase>
                    {item.eventCategories?.[0]?.title ?? ""}
                  </Paragraph>
                  <Paragraph className={styles.title} appearance="bold">
                    {item.title}
                  </Paragraph>
                </div>
                <Paragraph className={styles.date} appearance="bigger">
                  {item.eventTimeDescription}
                </Paragraph>
              </div>
            </div>
          </PageLink>
        );
      })}
    </div>
  );
};
